import { BaseClusterRenderer, MarkerTypeConfig } from "../../../../_shared/interfaces/maps/base-cluster-renderer";

export class FuelChangesClusterRenderer extends BaseClusterRenderer {

  protected override getMarkerTypesConfig(): { [key: string]: MarkerTypeConfig; } {
    return {
      'Fill-Up': { color: '#00A65A', pulsate: true },
      'Loss': { color: '#FFA500', pulsate: true },
    }
  }

  protected override getMarkerType(marker: google.maps.marker.AdvancedMarkerElement): string | null {
    const markerContentElement = marker.content as HTMLElement | null;
    return markerContentElement?.dataset?.['type']!;
  }
}